---
en:
  event_mapping:
    destroy_warning: This will deleting all previous event mappings for this wind turbine, are you sure you want to continue?
    file_too_large: File is too large
    import: Import event mappings
    invalid_file: The file could not be read. It may be corrupted or in the wrong format.
    no_file_selected: No file selected
    title: Event Mappings
    xlsx_file_input: XLSX file to upload
